export const handleAbort = (() => {
	let abortController: AbortController | null = null;
	return () => {
		abortController?.abort?.();
		abortController = new AbortController();
		return abortController.signal;
	};
})();
